import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { clientMutation } from "Core/data/GraphQLApi";
import { endpoints } from "Core/defaultValues";
import { ExceptionManager } from "Core/logManager";
import { resetALL } from "Redux/actions";

const INIT_STATE = {
    open: false,
    loading: false,
    result: null,
    error: null,
    items: [],
};

const route = 'modules/maintenance/views/main/components/emissionCheckTab/modals/delete/redux/slice';

export const deleteEmissionCheck = createAsyncThunk("emissionCheck/delete/action",
    async ({ ids }, { rejectWithValue }) => {
        try {
            const response = await clientMutation(
                `
                mutation deleteCarbSchedules($ids: [Int]!) {
                    data: deleteCarbSchedules(ids: $ids)
                }
                `,
                {
                    ids
                },
                endpoints.GRAPHQL_GENERAL_V2
            );

            return response?.data;
        } catch (exc) {
            ExceptionManager(exc, route, 'deleteEmissionCheck');
            return rejectWithValue(exc)
        }
    }
);

const emissionCheckDeleteRedux = createSlice({
    name: "emissionCheck/delete",
    initialState: INIT_STATE,
    reducers: {
        reset(state, action) {
            return action.payload ? { ...state, ...action.payload } : { ...INIT_STATE };
        },
        openDeleteEmissionCheck(state, action) {
            state.open = true;
            state.items = action?.payload?.items || [];
        },
    },
    extraReducers: (builder) => {
        //use for reset all when logout
        builder.addCase(resetALL, () => INIT_STATE);

        //manageDeleteManageCrew
        builder.addCase(deleteEmissionCheck.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(deleteEmissionCheck.fulfilled, (state, action) => {
            state.loading = false;
            state.result = action.payload;
        });
        builder.addCase(deleteEmissionCheck.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
    },
});

// Extract and export the action creators object and the reducer
export const { actions, reducer } = emissionCheckDeleteRedux;

// Extract and export each action creator by name
export const { reset, openDeleteEmissionCheck } = actions;

// Export the reducer, either as a default or named export
export default reducer;